module.exports = __webpack_public_path__ + "files/eac65d2621ab3127b0d406162e96d13b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-2.png
// module id = 1462
// module chunks = 60